import { useContext } from 'react';

import { ChainContext } from '../context';

export const useChain = () => useContext(ChainContext);
